import { createSelector } from 'reselect'

import type { UrgencyVelocityResponse, UrgencyVelocityStateType } from './types'

const MIN_URGENCY_COUNT = 100

export const urgencyLongtermSelector = createSelector(
    (state: UrgencyVelocityStateType) => state.data,
    (data: UrgencyVelocityResponse | undefined) => {
        const urgencyLongTerm = data?.items[0].data?.uLT
        if (!urgencyLongTerm) return undefined

        return urgencyLongTerm >= MIN_URGENCY_COUNT ? urgencyLongTerm.toLocaleString() : undefined
    },
)

const MIN_VELOCITY_COUNT = 20

export const velocityLongtermSelector = createSelector(
    (state: UrgencyVelocityStateType) => state.data,
    (data: UrgencyVelocityResponse | undefined) => {
        const velocityLongTerm = data?.items[0].data?.vLT
        if (!velocityLongTerm) return undefined

        return velocityLongTerm >= MIN_VELOCITY_COUNT ? velocityLongTerm.toLocaleString() : undefined
    },
)
